<template>
  <div class="center-wrap">

  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  export default {
    name: "message-center",
    data () {
      return {}
    },
  }
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/home/mine/center/index.vue